import React, { useEffect, useRef } from "react";
import ProductsNavbar from "../../components/Products/productsNavbar";
import Navbar from "../../components/NavBar";
import Footer from "../../components/Footer";

export default function Products() {
  const hasScrolled = useRef(false);

  useEffect(() => {
    // Only scroll to top on initial mount, not on every re-render
    if (!hasScrolled.current) {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      hasScrolled.current = true;
    }
  }, []);

  return (
    <div>
      <div className="wrapper">
        <div className="sticky-header">
          <Navbar />
        </div>
        <ProductsNavbar />
      </div>
      <Footer />
    </div>
  );
}
